import { render, staticRenderFns } from "./FueraDePlazo.vue?vue&type=template&id=b0638ab0"
import script from "./FueraDePlazo.vue?vue&type=script&lang=js"
export * from "./FueraDePlazo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports